<template>
  <div
    v-if="displayNorm"
    :class="classes"
    style="height: 20px;"
  >
    <span class="d-flex flex-row align-center justify-center ">{{ averageRange }}</span>
  </div>
  <div
    v-else
    style="width: 100%; height: 20px; margin-top: 5px;"
  />
</template>

<script>
import NormsMixin from '@/mixins/NormsMixin';
import { isEmpty } from 'lodash';

export default {
    mixins: [NormsMixin],
    props: {
        norm: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        symbol: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        conditionMatchError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            symboles: ['=', '<', '>'],
        };
    },
    computed: {
        displayNorm() {
            return !!this.value && this.norm;
        },
        getLegionellaNorm() {
            if (this.value >= this.norm.risk) {
                return `${this.$t('services.labels.higher')} ${this.norm.risk}`;
            } if (this.value < this.norm.risk && this.value >= this.norm.intervention) {
                return `${this.$t('services.labels.between')} ${this.norm.intervention}-${this.norm.risk}`;
            } return `${this.$t('services.labels.lower')} ${this.norm.intervention}`;
        },
        noNorm() {
            return (!this.norm || isEmpty(this.norm));
        },
        classes() {
            const colorClasss = this.color(this.value, this.norm, {
                type: this.type,
                symbol: this.symbol,
            });
            return ['d-flex', 'flex-row', 'align-center', 'justify-center', 'norm--container', colorClasss];
        },
        averageRange() {
            const { norm: { veryLow, low, minimum, maximum, high, veryHigh } } = this;
            const norms = { veryLow, low, minimum, maximum, high, veryHigh };

            if (this.conditionMatchError) {
                return this.$t('validations.messages.analysisCondition0To14');
            }

            if (this.conditionMatchError) {
                return this.$t('validations.messages.analysisCondition0To14');
            }

            if (this.noNorm && this.value) {
                return this.$t('services.visits.noLimits');
            }

            if (this.norm && this.value && (this.norm.risk || this.norm.intervention)) {
                return this.getLegionellaNorm;
            }

            if (this.value && this.isDefined(minimum) && this.isDefined(maximum)) {
                return `${minimum} - ${maximum}`;
            }

            if (this.value && this.isDefined(veryLow) && this.isDefined(low) && this.isDefined(minimum) && !this.isDefined(maximum)) {
                return `> ${minimum}`;
            }

            if (this.value && this.isDefined(maximum) && this.isDefined(high) && this.isDefined(veryHigh) && !this.isDefined(minimum)) {
                return `< ${maximum}`;
            }

            const nothingDefined = Object.values(norms).every(value => !this.isDefined(value));
            if (nothingDefined) {
                return this.$t('services.visits.noLimits');
            }

            return '';
        },
    },

};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/utils/_variables.scss";

.normsGreen {
    background-color: $norms-green !important;
    font-weight: 600;
    color: white;
    font-size: 0.8rem !important;
}

.normsYellow {
    background-color: $norms-yellow !important;
    font-weight: 600;
    color: white;
    font-size: 0.8rem !important;
}

.normsOrange {
    background-color: $norms-orange !important;
    font-weight: 600;
    color: white;
    font-size: 0.8rem !important;
}

.normsRed {
    background-color: $norms-red !important;
    font-weight: 600;
    color: white;
    font-size: 0.8rem !important;
}

.norm--container {
    min-height: 20px;
    margin-top: 5px;
    padding: 0px 5px;
    border-radius: 4px;
    background-color: #d9d9d9;
    width: 100%;
    font-size: 10px;

    span {
        font-size: 0.9em;
        width: 100%;
        height: 100%;
        margin-top: auto;
        margin-bottom: auto;
        letter-spacing: normal;
        text-align: center;
    }
}

</style>
